import React, { useState, useEffect, useMemo } from 'react';
import { Spin } from 'antd';
import AccountsBlock from '../../../../components/ui/AccountsBlock/AccountsBlock';
import { getEntitiesWithAddress } from '../../../../utils/getEntitiesWithAddress';
import useFlatsGridState from '../../../../hooks/useFlatsGridState';

const HousePersonalAccounts = () => {
  const [accounts, setAccounts] = useState([]);

  const { flatsGridState } = useFlatsGridState();

  const flats = useMemo(() => flatsGridState?.data || [], [flatsGridState]);

  useEffect(() => {
    if (flats.length) {
      const accounts = getEntitiesWithAddress(flats, 'accounts');

      setAccounts(accounts);
    }
  }, [flats]);

  return (
    <div>
      <Spin spinning={flatsGridState?.isFetching}>
        <AccountsBlock accounts={accounts} />
      </Spin>
    </div>
  );
};

export default HousePersonalAccounts;
